import Terms from 'src/app/Terms/Terms'

export default Terms
